import axios from 'axios'
import Vue from 'vue'

const vueObj = new Vue()

const state = {
  limit: 20,
  isFetching: false,
  isMore: true,
  serviceRequests: null,
  serviceRequestDetail: null,
  tmpConfirmPaymentData: null,
  bookingData: null,
  tmpServiceRequestPaymentData: null
}

const actions = {
  loadServiceRequestDetail: async ({commit}, id) => {
    commit('SET_SERVICE_REQUEST_DETAIL', null)
    const url = `service-requests/${id}`
    const res = await axios.get(url)
    const response = res.data
    if (!response.error) {
      commit('SET_SERVICE_REQUEST_DETAIL', response.service_request)
    } else {
      vueObj.$swal({text: res.data.message, type: 'error'})
    }
  },
  LOAD_SERVICE_REQUESTS: async ({commit}, queryData) => {
    commit('SET_IS_FETCHING', true)
    let {data} = await axios.get('service-requests', {
      params: queryData
    })
    if (!data.error) {
      commit('SET_IS_FETCHING', false)
      commit('SET_SERVICE_REQUESTS', data.service_requests)
    } else {
      commit('SET_IS_MORE', false)
      commit('SET_IS_FETCHING', false)
    }
  },
  LOAD_SERVICE_REQUEST_DETAIL: ({commit}, queryData) => {
    return new Promise(async (resolve, reject) => {
      commit('SET_SERVICE_REQUEST_DETAIL', null)
      const url = 'service-requests/' + queryData.id + `?validation=${queryData.validation}&provider=${queryData.provider}&userId=${queryData.userId}`
      let {data} = await axios.get(url)
      if (!data.error) {
        commit('SET_SERVICE_REQUEST_DETAIL', data.service_request)
        resolve('Success')
      } else {
        commit('SET_SERVICE_REQUEST_DETAIL', null)
        reject(new Error(data.message))
      }
    })
  },
  MAKE_PAYMENT: ({commit, rootState}, queryData) => {
    return new Promise(async (resolve, reject) => {
      console.log('rootState.globalState.customerApiUrl', rootState.globalVal.customerApiUrl)
      const FormData = {...queryData}
      console.log('queryData', FormData)
      /* let { data } = await axios.post(rootState.globalState.customerApiUrl + '/service-requests/' + queryData.id + '/payment', queryData)
       if (!data.error) {
         this.$refs.modal.close()
         resolve('success')
       } else {
         reject(data.message)
       } */
    })
  }
}

const mutations = {
  SET_SERVICE_REQUESTS: (state, data) => {
    if (data.length > 0) {
      state.serviceRequests.push(...data)
    } else {
      state.isMore = true
      state.serviceRequests = data
    }
  },
  SET_IS_FETCHING: (state, status) => {
    state.isFetching = status
  },
  SET_IS_MORE: (state, status) => {
    state.isMore = status
  },
  SET_SERVICE_REQUEST_DETAIL: (state, data) => {
    state.serviceRequestDetail = data
  },
  SET_TMP_PAYMENT_CONFIRM_DATA: (state, data) => {
    state.tmpConfirmPaymentData = data
  },
  SET_BOOKING_DATA: (state, data) => {
    state.bookingData = data
  },
  UPDATE_BOOKING_DATA: (state, data) => {
    state.bookingData[data.key] = data.value
  },
  SET_TMP_SERVICE_REQUEST_PAYMENT_DATA: (state, data) => {
    state.tmpServiceRequestPaymentData = data
  }
}

const getters = {
  getState: state => {
    return state
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/service.request.js